import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "login-box sign-up" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "logo-wrap" }
const _hoisted_4 = { href: "#" }
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = { class: "login-header" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h1", null, "Create an account", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Have an account ?", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Sign in")
const _hoisted_10 = { class: "form-wrap pt-0" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "First Name:", -1)
const _hoisted_15 = { class: "col-lg-4" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "Last Name:", -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "Email/Mobile:", -1)
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-3" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "country-code-select" }, "Country Code", -1)
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { for: "mobile" }, "Phone Number", -1)
const _hoisted_29 = {
  key: 1,
  class: "row"
}
const _hoisted_30 = { class: "col-lg-12" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-3" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "country-code-select" }, "Country Code ", -1)
const _hoisted_35 = { class: "col-lg-6" }
const _hoisted_36 = { class: "form-group mobile-holder" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "mobile" }, "Mobile Number:", -1)
const _hoisted_38 = {
  key: 0,
  class: "verified-mobile-icon"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"color":"green"}
}, null, -1)
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col-lg-4" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "OTP: (One Time Password)", -1)
const _hoisted_44 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_45 = { class: "form-group otp-counter" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "otp-mini-text" }, " (An OTP Code has been sent to your mobile phone)", -1)
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-lg-6" }
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createVNode("label", { for: "country-code-select" }, "Subscriptions ", -1)
const _hoisted_51 = { class: "btn-wrap" }
const _hoisted_52 = { class: "modal-wrap default-modal success-modal" }
const _hoisted_53 = {
  class: "modal fade",
  "data-keyboard": "false",
  id: "registerSuccessModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "msg-header text-center" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_59 = { class: "modal-body text-center" }
const _hoisted_60 = { class: "success-body mb-2" }
const _hoisted_61 = /*#__PURE__*/_createVNode("h5", null, "Account successfully created", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("p", null, " An email has been sent to you for verification. Please verify it. ", -1)
const _hoisted_63 = { class: "modal-footer" }
const _hoisted_64 = { class: "modal-wrap default-modal" }
const _hoisted_65 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "replaceRegister",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_66 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_67 = { class: "modal-content" }
const _hoisted_68 = { class: "modal-header" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Register Replace ")
], -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = { class: "form-wrap pt-0" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "modal-footer" }
const _hoisted_76 = {
  class: "alert alert-success text-center",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModal = _resolveComponent("SuccessfulModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("a", _hoisted_4, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl
            ? `${_ctx.state.data.imageBaseUrl}img/logo.png`
            : 'img/logo.png'
            
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("a", {
              href: "javascript:void(0)",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToLogIn && _ctx.redirectToLogIn(...args)))
            }, [
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.validationList,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    id: "name",
                    name: "name",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.registration.firstName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.registration.firstName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    id: "lastname",
                    name: "lastname",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.registration.lastName = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.registration.lastName]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createVNode("input", {
                type: "text",
                id: "username",
                name: "username",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.registration.signByInput = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.data.registration.signByInput]
              ])
            ]),
            (_ctx.isEmail)
              ? (_openBlock(), _createBlock("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _withDirectives(_createVNode("select", {
                            id: "country-code-select",
                            class: "custom-select form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.phone.code = $event))
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.countryCodeList, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: item.dial_code,
                                key: itemIndex
                              }, _toDisplayString(item.dial_code) + " " + _toDisplayString(item.name), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.state.data.phone.code]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_26, [
                        _createVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            id: "mobile",
                            name: "mobile",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.registration.phone = $event)),
                            placeholder: "Enter Mobile number of USA. eg. 2025550143 "
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.registration.phone]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.registration.notification.sms)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createVNode("select", {
                            id: "country-code-select",
                            class: "custom-select form-control",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.phone.mobileCode = $event)),
                            disabled: _ctx.state.data.phone.isVerify
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.countryCodeList, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: item.dial_code,
                                key: itemIndex
                              }, _toDisplayString(item.dial_code) + " " + _toDisplayString(item.name), 9, ["value"]))
                            }), 128))
                          ], 8, ["disabled"]), [
                            [_vModelSelect, _ctx.state.data.phone.mobileCode]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            id: "mobile_number",
                            name: "mobile_number",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.registration.mobile = $event)),
                            placeholder: "Enter Mobile number of USA. eg. 2025550143 ",
                            disabled: _ctx.state.data.phone.isVerify
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.state.data.registration.mobile]
                          ]),
                          (_ctx.state.data.phone.isVerify)
                            ? (_openBlock(), _createBlock("div", _hoisted_38, [
                                _hoisted_39
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("button", {
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args))),
                        class: _ctx.state.ui.verifyButton ? 'verify-phone-num btn-primary' : 'verify-phone-num btn-primary disabled'
                      }, "Verify", 2)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.state.ui.inputOtp)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      id: "otp",
                      name: "username",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.phone.otp = $event)),
                      onKeyup: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkInputValue && _ctx.checkInputValue(...args))),
                      number: ""
                    }, null, 544), [
                      [_vModelText, _ctx.state.data.phone.otp]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, _toDisplayString(_ctx.state.data.timeCount), 1),
                  _hoisted_46
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createVNode("select", {
                  id: "country-code-select",
                  class: "custom-select form-control",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.selectedSubscriptionId = $event))
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.registrationDetails.packages, (item, itemIndex) => {
                    return (_openBlock(), _createBlock("option", {
                      value: item.id,
                      key: itemIndex
                    }, _toDisplayString(item.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.state.data.selectedSubscriptionId]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_51, [
            _createVNode("a", {
              class: "btn d-block button-gradient",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
            }, " Sign Up ")
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_52, [
      _createVNode("div", _hoisted_53, [
        _createVNode("div", _hoisted_54, [
          _createVNode("div", _hoisted_55, [
            _createVNode("div", _hoisted_56, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideRegisterSuccessModal && _ctx.hideRegisterSuccessModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_57
              ]),
              _hoisted_58
            ]),
            _createVNode("div", _hoisted_59, [
              _createVNode("div", _hoisted_60, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/checked.jpg`
                : 'img/checked.jpg'
                ,
                  alt: ""
                }, null, 8, ["src"]),
                _hoisted_61,
                _hoisted_62
              ])
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn w-100",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideRegisterSuccessModal && _ctx.hideRegisterSuccessModal(...args)))
              }, " Continue ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _createVNode("div", _hoisted_66, [
          _createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _hoisted_69,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideReplaceRegister && _ctx.hideReplaceRegister(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_70
              ])
            ]),
            _createVNode("div", _hoisted_71, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.registerReplaceList,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_72, [
                (_ctx.state.data.registration.email)
                  ? (_openBlock(), _createBlock("p", _hoisted_73, " Do you want to replace registration with current email " + _toDisplayString(_ctx.state.data.registration.email) + "? ", 1))
                  : (_openBlock(), _createBlock("p", _hoisted_74, " Do you want to replace registration with current email ? "))
              ])
            ]),
            _createVNode("div", _hoisted_75, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.registerReplace && _ctx.registerReplace(...args)))
              }, _toDisplayString(_ctx.state.ui.postLoading.replaceRegister ? "Loading..." : "Yes"), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideReplaceRegister && _ctx.hideReplaceRegister(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModal, {
          key: 0,
          onClose: _ctx.closeSuccessModal,
          showModal: _ctx.state.data.showSuccesModal
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_76, _toDisplayString(_ctx.state.data.successFulMessage), 1)
          ]),
          _: 1
        }, 8, ["onClose", "showModal"]))
      : _createCommentVNode("", true)
  ], 64))
}